import * as schemas from '@tunein/reporting-schemas';
import { schemaRefToEventCodeMap } from '@tunein/reporting-schemas/constants';
import { mapValues } from 'es-toolkit';
import { Validator } from '../Validator';
export const tuneInEventValidators = mapValues(schemas, (schema) => new Validator(schema, schemaRefToEventCodeMap[schema.$ref]));
